import { Schema } from "yup";

/**
 * Set up checks to apply only if the product is selected
 * @param base The base schema to validate
 * @param schema The schema to check if the product is selected
 * @returns
 */
export const isSelected = <T extends unknown>(
    base: Schema<T>,
    schema: Schema<T>
): Schema<T> => {
    return base.when("isSelected", {
        is: (val) => val,
        then: schema,
        else: true
    });
};
